module.exports = __webpack_public_path__ + "static/media/DetailedLogoWhite.5f4f58be.png";